if (window.location.pathname == '/' || window.location.pathname == "/booking/iframe") {
    if (booking_status != '0') {

        window.checkGuestButton = async function (dayNameBookings) {

            if (dayNameBookings.max == 0 || dayNameBookings.max == null) {
                showNumber('+more');
                $('.booking_doguests').val('+more');
            } else {
                showNumber('-more');
                $('.booking_doguests').val(dayNameBookings.min);
            }

            renderInGuests(dayNameBookings);
        }


        $(document).on('focus', '.booking-step-one', function () {
            $('.booking-step-two').removeAttr('data-toggle');
        })

        $(document).on('click', '.booking_next_btn', () => {
            $('.booking-step-two').attr('data-toggle', 'pill');
            $('.booking-step-two').tab('show');

            let booking_guest = $('.booking_doguests').val();
            let booking_dotimepicker = $('.booking_dotimepicker').val();
            let booking_dodatepicker = $('.booking_dodatepicker').val();

            $('.booking-step-two').on('shown.bs.tab', function (e) {

                e.preventDefault()

                let html = '<tr>' +
                    '<th>Guests:</th>' +
                    '<td>' + booking_guest + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<th>Date:</th>' +
                    '<td>' + booking_dodatepicker + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<th>Time:</th>' +
                    '<td>' + booking_dotimepicker + '</td>' +
                    '</tr>';

                $('.info-table tbody').html(html);
            })
        })

        $(document).on('click', '.booking_pre_btn', () => {
            $('.booking-step-two').removeAttr('data-toggle');
            $('.booking-step-one').tab('show');
        })

        $(document).on('click', '#personNumber ul.picker__list li', function () {
            let val = $(this).val();
            $('input#booking_doguests').val(val);
            $('#personNumber').modal('hide');
            if (val == '+more' || val == 0) {
                showNumber('+more');
                $('.booking_doguests').val('+more');
            } else {
                showNumber('-more');
            }

        });

        $(document).on('focus', 'input#booking_doguests', function () {
            let val = $(this).val();
            if (val == '+more' || val == 0) {
                showNumber('+more');
                $('.booking_doguests').val('+more');
                $('#personNumber').modal('show');
            } else {
                showNumber('-more');
                $('#personNumber').modal('show');
            }
        });

        window.renderInGuests = function (data) {
            let htmlli = '<ul class="picker__list p-0" role="listbox" aria-controls="booking_doguests">';

            for (let i = data.min; i <= data.max; i++) {
                htmlli += '<li class="picker__list-item"' +
                    'data-pick="' + i + '"' +
                    'role="option"' +
                    'value="' + i + '"' +
                    'id="picker__list-item"' +
                    'aria-label = "' + i + '">' + i + '</li>';
            }
            htmlli += '<li class="picker__list-item"' +
                'data-pick="+more"' +
                'role="option"' +
                'value="+more"' +
                'id="picker__list-item"' +
                'aria-label = "+more">+More</li></ul>';

            /*$('.booking-guests div.picker__wrap div.picker__box li[value=' + $('.booking_doguests').val() + ']').addClass(
                'picker__list-item picker__list-item--selected picker__list-item--highlighted picker__list-item--viewset'
                ).
            attr('aria-activedescendant', true).attr('aria-selected', true);*/
            $('#personNumber .modal-body').html(htmlli);
        }

        $(document).on('click', '.booking_make_btn', function () {
            var values = $("#bookingForm").serializeArray();
            values.push({
                name: "special_note",
                value: $("#booking_special_note").val()
            });
            var delOne = values.indexOf('special_note');
            delete values[delOne];
            values = jQuery.param(values);

            $.ajax({
                url: window.location.origin + '/booking/make-booking',
                method: 'post',
                dataType: 'json',
                data: values,
                beforeSend: () => {
                    sendLoading();
                },
                success: (data) => {
                    sendDoneMsg(data);
                },
                error: (data) => {
                    sendDoneMsg(null);
                }
            })
        })

        window.sendLoading = function () {
            $('.booking_make_btn .spinner-border').removeClass('d-none');
            $('.booking-step-card').addClass('card-display-none');
        }

        window.sendDoneMsg = function (data = null) {
            bookingSetup();
            $('.booking_make_btn .spinner-border').addClass('d-none');
            $('.booking-step-card').removeClass('card-display-none');

            if (!auth) {
                $('#pills-step-two .r_data').val('');
            }

            $('.booking-step-one').tab('show');
            $('.booking-step-two').removeAttr('data-toggle');

            if (data) {
                $('#booking_special_note').val('');
                Swal.fire({
                    title: 'Your booking received',
                    icon: 'success',
                    html: 'Booking Reference: <strong style="font-weight: 600;">' + data.booking_id + '</<strong>'
                })
            }
        }

        window.showNumber = function (val) {
            if (val != '+more') {
                $('.booking_doguests2').hide();
                $('.booking_next_btn').removeClass('d-none');
            } else {
                $('.booking_doguests2').show();

                $('.booking_next_btn').addClass('d-none');
            }

            return true;
        }
    }
}